import React, { useState } from 'react';

const PASSWORD = 'aperture2026slate';

export default function ToolsGate({ onSuccess }) {
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      onSuccess();
    } else {
      setError(true);
      setShake(true);
      setInput('');
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center p-6" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-6px); }
          80% { transform: translateX(6px); }
        }
        .shake { animation: shake 0.45s ease; }
      `}</style>

      <div className="w-full max-w-md text-center">
        <a href="/#/" style={{ textDecoration: 'none' }}>
          <img src="/logo.png" alt="Aperture Slate" className="h-12 mx-auto mb-8 opacity-80" />
        </a>

        <p className="text-[11px] tracking-[0.4em] text-sky-400 font-bold uppercase mb-4">
          Aperture Slate // Filmmaker Tools
        </p>

        <h1 className="text-4xl font-black tracking-tight uppercase leading-none mb-2">Access</h1>
        <h1 className="text-4xl font-black tracking-tight uppercase leading-none text-zinc-600 mb-8">Required</h1>

        <div className="border border-zinc-800 bg-zinc-950 p-8 mb-6">
          <p className="text-zinc-400 text-sm leading-relaxed mb-6">
            Our filmmaker tools are available by invitation. To receive your access code, reach out directly.
          </p>

          <a
            href="mailto:hello@apertureslate.org?subject=Filmmaker Tools Access Request"
            style={{ textDecoration: 'none' }}
            className="block border border-zinc-700 text-zinc-300 text-[11px] font-bold tracking-widest uppercase py-3 px-4 hover:border-sky-500 hover:text-sky-400 transition-all duration-200 mb-8"
          >
            hello@apertureslate.org →
          </a>

          <div className="border-t border-zinc-900 pt-6">
            <p className="text-[10px] tracking-widest text-zinc-600 uppercase mb-4">Have an access code?</p>
            <form onSubmit={handleSubmit} className={shake ? 'shake' : ''}>
              <input
                type="password"
                value={input}
                onChange={(e) => { setInput(e.target.value); setError(false); }}
                placeholder="Enter access code"
                className={`w-full bg-zinc-900 border px-4 py-3 text-white text-sm tracking-wider focus:outline-none mb-3 transition-colors ${
                  error ? 'border-red-600 placeholder-red-900' : 'border-zinc-700 focus:border-sky-500'
                }`}
                style={{ fontFamily: 'inherit' }}
              />
              {error && (
                <p className="text-red-500 text-[11px] tracking-widest uppercase mb-3">Incorrect code. Contact us for access.</p>
              )}
              <button
                type="submit"
                className="w-full bg-white text-black text-[11px] font-black tracking-widest uppercase py-3 hover:bg-sky-400 transition-colors"
              >
                Enter
              </button>
            </form>
          </div>
        </div>

        <a href="/#/" style={{ textDecoration: 'none' }} className="text-[10px] text-zinc-700 hover:text-zinc-500 tracking-widest uppercase transition-colors">
          ← Return to Main Site
        </a>
      </div>
    </div>
  );
}
